import { FC } from 'react';

import { IAnalyticsStackedTimeSeriesSegment } from '../AnalyticsStackedTimeSeriesBox.types';
import { formatSegmentSummary } from '../AnalyticsStackedTimeSeriesBox.utils';

import { AnalyticsStackedTimeSeriesSegmentSwatch } from './AnalyticsStackedTimeSeriesSegmentSwatch';

interface IAnalyticsStackedTimeSeriesLegendProps {
  segments: IAnalyticsStackedTimeSeriesSegment[];
  segmentValueFormatter?: (value: number) => string;
}

export const AnalyticsStackedTimeSeriesLegend: FC<IAnalyticsStackedTimeSeriesLegendProps> = ({
  segments,
  segmentValueFormatter
}) => {
  const topOfStackFirstSegments = [...segments].reverse();

  if (topOfStackFirstSegments.length === 0) {
    return null;
  }

  return (
    <div className="flex justify-center gap-9">
      {topOfStackFirstSegments.map((segment) => (
        <div
          key={segment.key}
          data-testid={`analytics-stacked-time-series-box-legend-${segment.key}`}
          className="flex items-center gap-1.5"
        >
          <AnalyticsStackedTimeSeriesSegmentSwatch color={segment.color} />
          <span className="text-base-mutedForeground text-xs leading-none">
            {formatSegmentSummary(segment, segmentValueFormatter)}
          </span>
        </div>
      ))}
    </div>
  );
};
